import { NgModule } from '@angular/core';
import { SaisieComponent } from './saisie.component';
import { SharedModule } from '../shared/shared.module';
import { JuridictionsComponent } from './questionnaire/juridictions/juridictions.component';
import { QuestionnaireComponent } from './questionnaire/questionnaire.component';
import { RouterModule } from '@angular/router';
import { CanDeactivateGuard } from './can-deactivate/can-deactivate.guard';
import { DonneesGeneralesComponent } from './questionnaire/donnees-generales/donnees-generales.component';
import { BoutonsQuestionnaireComponent } from './questionnaire/boutons-questionnaire/boutons-questionnaire.component';
import { SelecteurQuestionnaireComponent } from './questionnaire/selecteur-questionnaire/selecteur-questionnaire.component';
import { FormulaireComponent } from './formulaire/formulaire.component';
import { ReactiveFormsModule } from  '@angular/forms';
import { MoyensComponent } from './questionnaire/moyens/moyens.component';
import { PremiersContactsComponent } from './questionnaire/premiers-contacts/premiers-contacts.component';
import { PersonnesRecuesComponent } from './questionnaire/personnes-recues/personnes-recues.component';
import { ContexteFaitsProcedureComponent } from './questionnaire/contexte-faits-procedure/contexte-faits-procedure.component';
import { AidesApporteesComponent } from './questionnaire/aides-apportees/aides-apportees.component';
import { BavComponent } from './questionnaire/bav/bav.component';
import { SyntheseBavComponent } from './questionnaire/synthese-bav/synthese-bav.component';
import { ListeBavComponent } from './questionnaire/liste-bav/liste-bav.component';
import { LieuxAssoComponent } from './questionnaire/moyens/lieux-asso/lieux-asso.component';
import { LieuxTjComponent } from './questionnaire/moyens/lieux-tj/lieux-tj.component';
import { LieuxBavComponent } from './questionnaire/moyens/lieux-bav/lieux-bav.component';
import { LieuxPolgendComponent } from './questionnaire/moyens/lieux-polgend/lieux-polgend.component';
import { LieuxFrservComponent } from './questionnaire/moyens/lieux-frserv/lieux-frserv.component';
import { LieuxSadComponent } from './questionnaire/moyens/lieux-sad/lieux-sad.component';
import { LieuxHostoComponent } from './questionnaire/moyens/lieux-hosto/lieux-hosto.component';
import { LieuxColterComponent } from './questionnaire/moyens/lieux-colter/lieux-colter.component';
import { LieuxAutrComponent } from './questionnaire/moyens/lieux-autr/lieux-autr.component';
import { ImpressionSaisieComponent } from './mode-rendu/impression-saisie.component';

@NgModule({
  declarations: [
    SaisieComponent,
    QuestionnaireComponent,
    JuridictionsComponent,
    DonneesGeneralesComponent,
    BoutonsQuestionnaireComponent,
    SelecteurQuestionnaireComponent,
    FormulaireComponent,
    MoyensComponent,
    PremiersContactsComponent,
    PersonnesRecuesComponent,
    ContexteFaitsProcedureComponent,
    AidesApporteesComponent,
    BavComponent,
    SyntheseBavComponent,
    ListeBavComponent,
    LieuxAssoComponent,
    LieuxTjComponent,
    LieuxBavComponent,
    LieuxPolgendComponent,
    LieuxFrservComponent,
    LieuxSadComponent,
    LieuxHostoComponent,
    LieuxColterComponent,
    LieuxAutrComponent,
    ImpressionSaisieComponent
  ],
  imports: [
    SharedModule,
    RouterModule,
    ReactiveFormsModule
  ],
  providers: [
    CanDeactivateGuard
  ],
  exports: [
    SaisieComponent,
    QuestionnaireComponent,
    FormulaireComponent
  ]
})
export class SaisieModule { }
